import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from '../../ui/loading/loading.component';

@Component({
	selector: 'app-my',
	standalone: true,
	imports: [RouterOutlet, LoadingComponent],
	templateUrl: './my.component.html',
	styleUrl: './my.component.scss',
})
export class MyComponent {}
